import { useState } from 'react';
import fromJS from 'transmute/fromJS';
import { useMutation } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import { SECTION_HEADER } from 'reporting-data/constants/dashboardWidgetType';
import AddSectionHeaderToDashboardDialog from './AddSectionHeaderToDashboardDialog';
// @ts-expect-error untyped module
import { useHideDialog } from '../../../dialog/ducks';
// @ts-expect-error untyped module
import { SAVE_WIDGETS_TO_DASHBOARD } from '../../../data/requests/dashboards';
// @ts-expect-error untyped module
import { UPDATE_REPORT } from '../../../data/requests/report';
// @ts-expect-error untyped module
import { getNonReportWidgetConfig } from '../../../data/schemas/reportSchema';
// @ts-expect-error untyped module
import { ACTION_STATUSES } from '../../shared/actionStatuses';
import rethrow from 'reporting-data/lib/rethrow';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const AddSectionHeaderToDashboardDialogContainer = ({
  dashboardId,
  prevSectionHeaderWidgetReport,
  onSaveSuccess = () => {},
  appUsageTracker
}) => {
  const prevSectionHeaderConfig = getNonReportWidgetConfig(prevSectionHeaderWidgetReport);
  const usageTracker = useTracker(appUsageTracker);
  const hideDialog = useHideDialog();
  const [actionStatus, setActionStatus] = useState(ACTION_STATUSES.NOT_STARTED);
  const onCompleted = () => {
    setActionStatus(ACTION_STATUSES.COMPLETE);
    ReportActionsFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.addSectionHeader.dialog.saveSuccess"
      }),
      type: 'success'
    });
    hideDialog();
    onSaveSuccess === null || onSaveSuccess === void 0 || onSaveSuccess();
    usageTracker === null || usageTracker === void 0 || usageTracker.track(EVENTS.completeAddSectionHeaderToDashboardButton, {
      actionType: 'create',
      action: 'complete-add-section-header-to-dashboard',
      assetType: 'dashboard'
    });
  };
  const onError = error => {
    setActionStatus(ACTION_STATUSES.FAILED);
    console.error(error);
    ReportActionsFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.addSectionHeader.dialog.saveError"
      }),
      type: 'danger'
    });
  };
  const [saveWidgetsToDashboard] = useMutation(SAVE_WIDGETS_TO_DASHBOARD, {
    onCompleted,
    onError
  });
  const [updateReport] = useMutation(UPDATE_REPORT, {
    onCompleted,
    onError
  });
  const updateSectionHeaderWidgetReport = ({
    sectionHeading,
    sectionDescription
  }) => {
    const newReport = prevSectionHeaderWidgetReport.setIn(['nonReportWidget', 'widgetConfig'], fromJS({
      name: sectionHeading,
      description: sectionDescription
    }));
    updateReport({
      variables: {
        newReport
      }
    }).catch(rethrow);
  };
  const saveNewSectionHeaderWidgetReport = ({
    sectionHeading,
    sectionDescription
  }) => {
    const newSectionHeaderWidgetReport = {
      nonReportWidget: {
        widgetType: SECTION_HEADER,
        widgetConfig: {
          name: sectionHeading,
          description: sectionDescription
        }
      },
      name: sectionHeading
    };
    saveWidgetsToDashboard({
      variables: {
        widgetReports: [newSectionHeaderWidgetReport],
        dashboardId
      }
    }).catch(rethrow);
  };
  const handleSaveSectionHeaderWidgetToDashboard = ({
    sectionHeading,
    sectionDescription
  }) => {
    setActionStatus(ACTION_STATUSES.PENDING);
    if (prevSectionHeaderWidgetReport) {
      updateSectionHeaderWidgetReport({
        sectionHeading,
        sectionDescription
      });
    } else {
      saveNewSectionHeaderWidgetReport({
        sectionHeading,
        sectionDescription
      });
    }
  };
  return /*#__PURE__*/_jsx(AddSectionHeaderToDashboardDialog, {
    onSave: handleSaveSectionHeaderWidgetToDashboard,
    actionStatus: actionStatus,
    prevSectionHeading: prevSectionHeaderConfig ? prevSectionHeaderConfig.get('name') : '',
    prevSectionDescription: prevSectionHeaderConfig ? prevSectionHeaderConfig.get('description') : ''
  });
};
export default AddSectionHeaderToDashboardDialogContainer;